"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _web = require("@react-hookz/web");
var _designTokens = require("@smartsheet/design-tokens");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _avatar = require("../../../avatar");
var _flyout = require("../../../flyout");
var _useDelayedOpen = require("../../../flyout/hooks/useDelayedOpen");
var _contactPickerConstants = require("../../contactPickerConstants");
var _contactPickerTheme = require("../../contactPickerTheme");
var _types = require("../../types");
var _GroupOptionItem = require("../SinglePicker/GroupOptionItem");
var _IndividualOptionItem = require("../SinglePicker/IndividualOptionItem");
var _OptionAvatarWrap = require("./OptionAvatarWrap");
var _OptionBodyWrap = require("./OptionBodyWrap");
var _OptionCheckMark = require("./OptionCheckMark");
var _OptionContactCard = require("./OptionContactCard");
var _OptionRoot = require("./OptionRoot");
const OptionItem = _ref => {
  let {
    option,
    index,
    highlightedIndex,
    optionSpreadProps,
    isOptionSelected,
    internalInputValue,
    portalProps,
    onViewMembers,
    singleOrMulti,
    optionToString,
    suppressContactCard
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [isContactCardOpenOverride, setIsContactCardOpenOverride] = _react.default.useState(false);
  const {
    isOpen,
    getDelayedOpenTargetProps
  } = (0, _useDelayedOpen.useDelayedOpen)({
    delayMode: "each",
    enterDelay: _contactPickerConstants.CONTACT_CARD_ENTER_DELAY
  });
  const {
    flyoutProps,
    targetProps
  } = (0, _flyout.useFlyout)({
    isOpen,
    onCloseRequested: () => setIsContactCardOpenOverride(false),
    placement: "top-start",
    hasArrow: false,
    offset: {
      distance: -10,
      skidding: 40
    },
    portalProps
  });
  const isHighlighted = index === highlightedIndex; // HOVERED
  const combinedRef = (0, _lodestarUtils.useForkRef)(optionSpreadProps.ref, targetProps.ref);
  const checkmark = /*#__PURE__*/_react.default.createElement(_OptionCheckMark.OptionCheckMark, {
    singleOrMulti: singleOrMulti,
    isOptionSelected: isOptionSelected
  });
  const sharedAvatarProps = {
    "aria-hidden": true,
    size: _contactPickerTheme.contactPickerTheme.option.avatar.size(themeMode),
    role: "presentation",
    tabIndex: -1
  };
  const avatarProps = (0, _types.isGroupContact)(option) ? {
    color: {
      // TODO we'll need ursa colors for this one.
      backgroundColor: _designTokens.lodestarColors.visBlueLight20,
      textColor: _designTokens.lodestarColors.neutralDark40
    },
    content: _contactPickerTheme.groupAvatarIcon[themeMode]
  } : {
    src: option.profileImageUrl,
    initials: option.initials,
    email: option.emailAddress || option.id || option.name
  };

  // We need to make sure the ContactCard stays up when the user's mouse is on it.
  const finalContactCardIsOpen = !suppressContactCard && isHighlighted && (flyoutProps.isOpen || isContactCardOpenOverride);
  const previousFinalContactCardIsOpen = (0, _web.usePrevious)(finalContactCardIsOpen);
  (0, _react.useEffect)(() => {
    // When the contact card finally does close, we want to reset the lock to ensure the
    // delayedOpen functionality can work again the next time the user hovers over an option.
    if (previousFinalContactCardIsOpen && !finalContactCardIsOpen) {
      setIsContactCardOpenOverride(false);
    }
  }, [previousFinalContactCardIsOpen, finalContactCardIsOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, flyoutProps, {
    isOpen: finalContactCardIsOpen
  }), /*#__PURE__*/_react.default.createElement(_OptionContactCard.OptionContactCard
  // We set this to true to make sure the ContactCard stays up when the user's
  // mouse is on it.
  , {
    onMouseEnter: () => setIsContactCardOpenOverride(true),
    onMouseLeave: () => setIsContactCardOpenOverride(false),
    onViewMembers: onViewMembers,
    option: option
  })), /*#__PURE__*/_react.default.createElement(_OptionRoot.OptionRoot, (0, _extends2.default)({}, targetProps, optionSpreadProps, getDelayedOpenTargetProps(), {
    ref: combinedRef,
    isHighlighted: isHighlighted,
    themeMode: themeMode
  }), _contactPickerTheme.contactPickerTheme.checkmark.position[singleOrMulti](themeMode) === "before" && checkmark, /*#__PURE__*/_react.default.createElement(_OptionAvatarWrap.OptionAvatarWrap, {
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_avatar.Avatar, (0, _extends2.default)({}, sharedAvatarProps, avatarProps))), /*#__PURE__*/_react.default.createElement(_OptionBodyWrap.OptionBodyWrap, {
    themeMode: themeMode
  }, (0, _types.isGroupContact)(option) ? /*#__PURE__*/_react.default.createElement(_GroupOptionItem.GroupOptionItem, {
    option: option,
    internalInputValue: internalInputValue,
    optionToString: optionToString
  }) : /*#__PURE__*/_react.default.createElement(_IndividualOptionItem.IndividualOptionItem, {
    internalInputValue: internalInputValue,
    option: option,
    optionToString: optionToString
  })), _contactPickerTheme.contactPickerTheme.checkmark.position[singleOrMulti](themeMode) === "after" && checkmark));
};
exports.OptionItem = OptionItem;
//# sourceMappingURL=OptionItem.js.map